module.exports = __webpack_public_path__ + "static/advica-logo-6edd18a3bceb78bb51c69a166edd32a4.jpeg";